import React from "react";
import { CToast, CToastBody, CToaster, CToastHeader } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilCheckAlt, cilX, cilBell } from "@coreui/icons";

const ToastNotification = ({ toast, setToast }) => {
  // Define se deve esconder automáticamente
  const autohide = toast?.autoClose !== false;
  // Delay só importa se autohide for true
  const delay = autohide ? toast?.delay ?? 5000 : 0;

  const toastColor =
    toast?.type === "error"
      ? "#dc3545"
      : toast?.type === "success"
      ? "#28a745"
      : toast?.type === "warning"
      ? "#ffeeba"
      : null;

  return (
    <CToaster
      placement="top-end"
      style={{ marginTop: "70px", marginRight: "20px" }}
    >
      {toast?.message && toast?.type && (
        <CToast
          autohide={autohide}
          delay={delay}
          visible
          onClose={() => setToast(null)}
        >
          {toast?.title && (
            <CToastHeader closeButton>
              {toastColor && (
                <div
                  className="rounded me-2 d-flex align-items-center justify-content-center"
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: toastColor,
                  }}
                >
                  {toast.type === "success" && (
                    <CIcon icon={cilCheckAlt} className="text-white" />
                  )}
                  {toast.type === "error" && (
                    <CIcon icon={cilX} className="text-white" />
                  )}
                  {toast.type === "warning" && (
                    <CIcon icon={cilBell} className="text-white" />
                  )}
                </div>
              )}
              <div className="fw-bold me-auto">{toast.title}</div>
            </CToastHeader>
          )}
          <CToastBody>{toast.message}</CToastBody>
        </CToast>
      )}
    </CToaster>
  );
};

export default ToastNotification;
